import { ClassifyCurdVm } from "../../models/view/classify-curd.vm";

export class GetClassifyParamCommand {
    constructor(public getClassify: ClassifyCurdVm) {
    }
}
